import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import {Button} from '@mui/material';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {i18n} from 'src/i18n';
import auditLogSelectors from 'src/modules/auditLog/auditLogSelectors';
import destroyActions from 'src/modules/gestorDocumental/destroy/gestorDocumentalDestroyActions';
import destroySelectors from 'src/modules/gestorDocumental/destroy/gestorDocumentalDestroySelectors';
import gestorDocumentalSelectors from 'src/modules/gestorDocumental/gestorDocumentalSelectors';
import ConfirmModal from 'src/view/shared/modals/ConfirmModal';
import ToolbarWrapper from 'src/view/shared/styles/ToolbarWrapper';

function GestorDocumentalViewToolbar(props) {
  const [destroyConfirmVisible, setDestroyConfirmVisible] = useState(false);

  const dispatch = useDispatch();

  const id = props.match.params.id;

  const hasPermissionToAuditLogs = useSelector(auditLogSelectors.selectPermissionToRead);
  const hasPermissionToEdit = useSelector(gestorDocumentalSelectors.selectPermissionToEdit);
  const hasPermissionToDestroy = useSelector(gestorDocumentalSelectors.selectPermissionToDestroy);
  const destroyLoading = useSelector(destroySelectors.selectLoading);

  const doOpenDestroyConfirmModal = () => {
    setDestroyConfirmVisible(true);
  };

  const doCloseDestroyConfirmModal = () => {
    setDestroyConfirmVisible(false);
  };

  const doDestroy = () => {
    doCloseDestroyConfirmModal();
    dispatch(destroyActions.doDestroy(id));
  };

  return (
    <ToolbarWrapper>
      {hasPermissionToEdit && (
        <Button
          component={Link}
          to={`/gestor-documental/${id}/edit`}
          variant="contained"
          color="primary"
          type="button"
          startIcon={<EditIcon />}
          size="small">
          {i18n('common.edit')}
        </Button>
      )}

      {hasPermissionToDestroy && (
        <Button
          variant="contained"
          color="primary"
          type="button"
          startIcon={<DeleteIcon />}
          disabled={destroyLoading}
          onClick={doOpenDestroyConfirmModal}
          size="small">
          {i18n('common.destroy')}
        </Button>
      )}

      {hasPermissionToAuditLogs && (
        <Button component={Link} to={`/audit-logs?entityId=${encodeURIComponent(id)}`} startIcon={<HistoryIcon />} size="small">
          {i18n('auditLog.menu')}
        </Button>
      )}

      {destroyConfirmVisible && (
        <ConfirmModal
          title={i18n('common.areYouSure')}
          onConfirm={() => doDestroy()}
          onClose={() => doCloseDestroyConfirmModal()}
          okText={i18n('common.yes')}
          cancelText={i18n('common.no')}
        />
      )}
    </ToolbarWrapper>
  );
}

export default GestorDocumentalViewToolbar;
